import { createSlice } from "@reduxjs/toolkit";
import odooApprovedApi from "@custom/rtk-apis/hospital/odooApproved";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: "",
};

const odooApprovedSlice = createSlice({
    name: "odooApprovedSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(odooApprovedApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(odooApprovedApi.fulfilled, (state, { payload }) => {
                console.log('payload', payload)
                state.loading = false;
                state.status = payload.status;
                state.result = payload.result;
                state.msg = payload.msg;
            })
            .addCase(odooApprovedApi.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default odooApprovedSlice.reducer;
